import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { appRoutes } from "config/appRoutes.config";
import View from "components/elements/View";
import getAuthority from "utils/getAuthority";
import setPathToRedirect from "helpers/setPathToRedirect";
import MenuCard from "./components/MenuCard";

function App(): JSX.Element {
  const { t } = useTranslation();
  const userRoles = getAuthority();

  return (
    <View title={t("home.title")} withGreyBackground withBreadcrumbs={false}>
      <Row gutter={[20, 20]}>
        {appRoutes.map(
          ({
            name,
            path,
            productionPath,
            Icon,
            description,
            hideInMenu,
            authority,
            external,
          }) => {
            const userHasRequiredRole =
              userRoles && authority
                ? authority.some((el) => userRoles.indexOf(el) !== -1)
                : true;

            const isHidden = hideInMenu || !userHasRequiredRole;
            const pathToRedirect = setPathToRedirect(productionPath, path);
            return isHidden ? null : (
              <Col key={name}>
                <MenuCard
                  to={pathToRedirect}
                  title={t(name)}
                  Icon={Icon && <Icon width={50} height={50} />}
                  description={description}
                  external={external}
                />
              </Col>
            );
          }
        )}
      </Row>
    </View>
  );
}

export default App;
